export function suspend<T>(promise: Promise<T>): never {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw promise;
}
